import { SxProps, Theme } from '@mui/material';

export const tileDescriptionSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: {
		xs: 'var(--font-size-small)',
		sm: 'var(--font-size-default)',
	},
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
	marginRight: '7px',
};

export const linkTitleSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#011688',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'none',

	'&:hover': {
		textDecoration: 'none',
	},
};

export const tileDescriptionDrawerSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-body)',
	letterSpacing: '0px',
	color: '#333333',
	fontWeight: 'bold',
	opacity: 1,
};

export const numberDrawerAttrSx: SxProps = {
	display: 'inline',
	alignItems: 'left',
	fontSize: 'var(--font-size-default)',
	color: '#14BDD1',
	fontWeight: 'bold',
	letterSpacing: '0',
};

export const textNumberDrawerSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	display: 'inline',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#313131',
	fontWeight: 'bold',
	opacity: 1,
	marginLeft: '3px',
};

export const subTextNumberDrawerSx: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#808080',
	fontWeight: 'normal',
	opacity: 1,
};

export const textSubtitle2DrawerSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-caption)',
	letterSpacing: '0px',
	color: '#808080',
	fontWeight: 'bold',
	opacity: 1,
};

export const textLittleSx: SxProps = {
	display: 'inline',
	alignItems: 'left',
	fontSize: 'var(--font-size-small)',
	color: '#313131',
	fontWeight: 'normal',
	letterSpacing: '0',
};

export const textLittlelinkTitleSX: SxProps<Theme> = {
	display: 'inline',
	fontSize: 'var(--font-size-small)',
	letterSpacing: '0px',
	color: '#0064C8',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'none',
	marginLeft: '3px',
	'&:hover': {
		textDecoration: 'none',
	},
};

export const buttonAplazoSX: SxProps<Theme> = {
	width: '145px',
	height: '40px',
	backgroundColor: '#000000',
	fontSize: 'var(--font-size-default)',
	color: '#FFFFFF',
	fontWeight: 'bold',
	borderRadius: '20px',
};

export const titleIconSx: SxProps = {
	alignItems: 'left',
	fontSize: 'var(--font-size-default)',
	color: '#313131',
	fontWeight: 'bold',
	letterSpacing: '0',
};

export const subTitleIconSx: SxProps = {
	alignItems: 'left',
	fontSize: 'var(--font-size-caption)',
	color: '#313131',
	fontWeight: 'normal',
	letterSpacing: '0',
};
